import { FloorLampIcon } from './FloorLampIcon';

/**
 * author: GreenTurtwig
 * id BEF1218E-7AF7-45F9-930E-915791D51EDC
 * name floor-lamp
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/floor-lamp.svg
 * tags
 * - Home Automation 
 */
export const FloorLightIcon = FloorLampIcon;
export default FloorLightIcon